import React from "react";
import HandCoinsIcon from "./../../../icons/HandCoinsIcon";
import SealCheckIcon from "./../../../icons/SealCheckIcon";
import LineSegmentIcon from "./../../../icons/LineSegmentIcon";

/*
<BenefitsOfBuyingCard title="Benefits of buying auctioned property" />
*/

interface BenefitsOfBuyingCardProps {
  title: string;
  icon1?: React.ReactElement;
  icon2?: React.ReactElement;
  icon3?: React.ReactElement;
  styles?: {
    wrapper?: string;
    titleWrapper?: string;
    title?: string;
  };
}

export default function BenefitsOfBuyingCard({
  title,
  icon1,
  icon2,
  icon3,
  styles,
}: BenefitsOfBuyingCardProps) {
  return (
    <div
      className={`max-w-[260px] bg-brand-lightBlue bg-wave-pattern1 bg-no-repeat bg-contain clip-path-mobileClipPolygonBottomRight hover:shadow-lg hover:scale-[1.01] hover:shadow-300 hover:duration-300 hover:ease-out ${styles?.wrapper}`}
    >
      <div className={`pl-[21px] pr-6 pt-5 pb-[37px] ${styles?.titleWrapper}`}>
        <p
          className={`font-ibmPlex font-medium text-web-body-lg text-brand-textBlack ${styles?.title}`}
        >
          {title}
        </p>
      </div>

      <div
        className={`grid grid-cols-3 items-center justify-center pl-3 pb-[37px] mr-[46px]`}
      >
        <div className="flex flex-col items-center justify-center font-inter">
          <div>{icon1 || <HandCoinsIcon />}</div>
          <div className="text-xs font-inter mt-[6px] font-normal text-center">
            Cost Benefit
          </div>
        </div>
        <div className="flex flex-col items-center justify-center font-inter">
          <div>{icon2 || <SealCheckIcon />}</div>
          <div className="text-xs font-inter mt-[6px] font-normal text-center">
            Verified Sellers
          </div>
        </div>
        <div className="flex flex-col items-center justify-center font-inter">
          <div>{icon3 || <LineSegmentIcon />}</div>
          <div className="text-xs font-inter mt-[6px] font-normal text-center">
            Easy Process
          </div>
        </div>
      </div>
    </div>
  );
}
